import type { Session } from '@/features/auth/types'

/** The contract's own test: a session at no Standort is the platform admin's. */
export function isPlatformSession(session: Session): boolean {
  return session.location === null
}
